"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { FileText, FileSpreadsheet, PenTool, BookOpen, LayoutTemplate, Package, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specifierTools = [{
  title: "CSI 3-part specifications",
  description: "MasterFormat-ready spec language for the identification section.",
  link: "/compliance/submittal-templates/",
  icon: FileText
}, {
  title: "Material data sheets",
  description: "Spec sheets for phenolic, acrylic, stainless, aluminum, and brass.",
  link: "/materials/",
  icon: FileSpreadsheet
}, {
  title: "Basis-of-design language",
  description: "Drop-in text naming Evermark as the basis of design.",
  link: "/services/submittal-packages/",
  icon: PenTool
}, {
  title: "Standards references",
  description: "UL 508A, NFPA 70E, NEC 110.16, ANSI Z535, MIL-SPEC, mapped to products.",
  link: "/compliance/",
  icon: BookOpen
}, {
  title: "Submittal templates",
  description: "Pre-built submittal documents for review.",
  link: "/compliance/submittal-templates/",
  icon: LayoutTemplate
}, {
  title: "Sample kit",
  description: "Physical material samples to evaluate before specifying.",
  link: "/resources/sample-kit/",
  icon: Package
}];
export default function WhatEvermarkGivesSpecifiers() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}